import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { FormItem, FileReader } from '../../../../components';
import type { FormProps } from './CallTaskWizard';

interface SecondStepWizardProps {
  values: FormProps;
}

const SecondStepWizard: React.FC<SecondStepWizardProps> = ({ values }) => {
  return (
    <div className="flex flex-col gap-y-12 w-full items-center mt-10">
      <div className="items-center">
        <div className="flex flex-col mb-4 self-start">
          <h3 className="text-2xl font-semibold">Import Contacts</h3>
          <span className="text-tiny text-secondary">
            Upload the file with the contacts
          </span>
        </div>
        <div className="flex items-center p-4 rounded-lg bg-gray-200 border border-gray-400 my-6">
          <ErrorIcon className="mr-2" />
          <span className="text-secondary">
            We support a file with 3 columns (Contact name, Phone number and
            Notes)
          </span>
        </div>
        <div className="flex flex-col items-start w-full">
          <FormItem<FormProps>
            required
            name="file"
            label=""
            inline={false}
            renderError={() => null}
          >
            <FileReader
              uploadButtonText="Upload Contacts"
              requiredColumns={['contact_name', 'phone_number', 'notes']}
              label="Upload CSV or Excel file with contacts"
              onChange={(rows, file) => {
                console.log('Uploaded contacts:', rows);
              }}
            />
          </FormItem>
        </div>
      </div>
    </div>
  );
};

export default SecondStepWizard;
